import { useEffect, useState } from "react";

const SidebarLinkGroup = ({
  children,
  activeCondition,
}: {
  children: (handleClick: () => void, open: boolean) => React.ReactNode;
  activeCondition: boolean;
}) => {
  const [open, setOpen] = useState<boolean>(activeCondition);

  useEffect(() => {
    if (activeCondition) {
      setOpen(true);
    }
  }, [activeCondition]);

  const handleClick = () => setOpen((prev) => !prev);

  return <>{children(handleClick, open)}</>;
};

export default SidebarLinkGroup;
